import { createStore, createEvent } from "effector"
import { IArticleSidebarProps } from "components/ArticleSidebar/ArticleSidebar"

const show = createEvent<IArticleSidebarProps>()
const hide = createEvent<IArticleSidebarProps>()
const clear = createEvent()

const list = createStore<IArticleSidebarProps[]>([])

list.on(show,
    (state: IArticleSidebarProps[], props: IArticleSidebarProps) => {
        return [...state, props]
    }
)

list.on(hide,
    (state: IArticleSidebarProps[], props: IArticleSidebarProps) => {
        return state.filter(p => p !== props)
    }
)

list.on(clear,
    () => []
)

export default {
    show,
    hide,
    clear,
    list,
}
